import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { DateTime } from 'luxon';

import { Project } from '@apps/pata/domain/models';
import { ProjectState } from '@apps/pata/models';
import { ProjectClassificationEnum } from '@apps/pata/enums';

export const PataProjectFeatureKey = 'projects';

type IProjectState = EntityState<Project>;
export const projectsAdapter: EntityAdapter<Project> = createEntityAdapter({
    selectId: (project: Project) => project.projectNumber
});
const projectsInitialState: IProjectState = projectsAdapter.getInitialState({});

export interface IPataProjectsState {
    projects: IProjectState;
    isLoading: boolean;
    isLoaded: boolean;
    isEmpty: boolean;
    isOups: boolean;
    qsWord: string;
    expirationDate: DateTime;
    filterStatus: boolean;
    classification: ProjectClassificationEnum;
}

export const PataProjectsInitialState: IPataProjectsState = {
    projects: projectsInitialState,
    isLoading: false,
    isLoaded: false,
    isEmpty: false,
    isOups: false,
    qsWord: '',
    expirationDate: null,
    filterStatus: ProjectState.open.status,
    classification: ProjectClassificationEnum.Activity
};
